import { CustomButton, SwitchButton, SearchBar } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import { setLocalStorage } from "config/config";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { toast } from "sonner";
import { userPlaceholder } from "assets/icons";
import { hastagListApi, removehastagApi, updateStatus } from "services/hashtag";
import AddHasTagManagement from "./AddHashtag";
import EditHashtagManagement from "./EditHashtag";
const HashtagManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [hastagList, setHastagList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [changeHastag, setChangeHastag] = useState(false);
  const [editHastag, setEditHastag] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const userValue = searchParams.get("status") || "";
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loader, onShow, onHide] = useFullPageLoader();
  const [types, setTypes] = useState("app");
  const [inputData, setInputData] = useState({});
  const navigate = useNavigate();
  // sorting
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelected({ id, action: "delete" });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await removehastagApi(selected.id);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        setDeleteModal(false);
        hastagListHandler();
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };
  // change student status
  const statusHandler = (studentId, status) => {
    setSelected({
      ...selected,
      id: studentId,
      status: status === "true" ? "false" : "true",
      action: "changeStatus",
    });
    setStatusModal(true);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await updateStatus(selected);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        hastagListHandler();
      } else {
        toastMessage(res.data.message, "error", "changeStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");
    setSearch("");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelected({});
  };
  //-----------status-------------
  const handleUserType = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  // student list handler
  const hastagListHandler = async (
    page = activePage,
    limit = "10",
    type = types ? types : "app",
    search = debouncedValue,
    sortField = fieldName || "createdAt",
    sortDirection = direaction,
    userType = userValue
  ) => {
    try {
      onShow();
      const res = await hastagListApi({
        page,
        search,
        limit,
        type,
        sortField,
        sortDirection,
        userType,
      });
      if (res?.data?.status === 200) {
        setTotal(res?.data?.data?.total);
        setHastagList(res.data?.data?.list);
        onHide();
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    hastagListHandler();
  }, [searchParams, debouncedValue, fieldName, direaction, types, userValue]);

  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);

  useEffect(() => {
    setLocalStorage("hastagList", "search", search);
  }, [search]);

  return (
    <>
      <div className="student_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3>Hashtag Management</h3>
            <div className="d-flex">
              <CustomButton onClick={() => setChangeHastag(true)} className="mx-2">
                Add Hashtag
              </CustomButton>

            </div>
          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />

              <div className="d-flex">
                <select
                  className="input form-control"
                  value={userValue}
                  onChange={handleUserType}
                >
                  <option value={""}>Select User Type</option>
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </select>
                <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>

              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("hashtagNumber")}
                    >
                      Hashtag number
                      <span className="shorting">
                        {fieldName === "hashtagNumber"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap cursor-pointer" onClick={() => handleSort("title")}>
                      Name
                      <span className="shorting">
                        {fieldName === "title"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap cursor-pointer text-center"
                      onClick={() => handleSort("postCount")}
                    >
                      Times Used
                      <span className="shorting">
                        {fieldName === "postCount"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {hastagList && hastagList.length > 0 ? (
                    hastagList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          <td>{++index + (activePage - 1) * 10}</td>

                          <td>{data.hashtagNumber}</td>

                          <td className="nowrap">
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(
                                  `/post-management?title=${data?.title.replace(
                                    "#",
                                    ""
                                  )}`
                                );
                              }}
                            >
                              {data?.title}
                            </Link>
                          </td>

                          <td className="nowrap text-center">{data?.postCount}</td>
                          <td>
                            {" "}
                            <div className="icon_wrap">
                              {/* <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  statusHandler(
                                    data._id,
                                    data?.status.toString()
                                  )
                                }
                                }
                              >
                                <SwitchButton
                                  status={data?.status.toString()}
                                />
                              </Link> */}
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?._id);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                              {/* <Link
                                onClick={() => {
                                  setEditHastag(true)
                                  setInputData(data)
                                }}
                                className="icon_button"
                              >
                                <FaRegEdit />
                              </Link> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"Hashtag data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelected({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Hashtag?"
        title="Delete Hashtag"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />
      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this Hashtag?"
        title="Change Status"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />
      <CustomModal
        className={"image_preview_modal"}
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
      >
        <div className="image_preview">
          <img src={imageUrl ? imageUrl : userPlaceholder} alt="" />
        </div>
      </CustomModal>

      {/* Add Banner */}

      <AddHasTagManagement
        setChangeHastag={setChangeHastag}
        changeHastag={changeHastag}
        type={types}
        hastagListHandler={hastagListHandler}
      />
      <EditHashtagManagement
        setEditHastag={setEditHastag}
        editHastag={editHastag}
        inputData={inputData}
        setInputData={setInputData}
        hastagListHandler={hastagListHandler}
      />
    </>
  );
};

export default HashtagManagement;
